import {
  Landing,
  MobileNumberLogin,
  MobileNumberRegister,
  MobileNumberContactUs,
  MobileNumberVerification,
  EmailAddressLogin,
  EmailAddressVerification,
  EmailAddressContactUs,
  EmailAddressRegister,
  TelkomIdLogin,
  TelkomIdContactUs,
  UsernameLogin,
  UsernameRegister,
  UsernameContactUs,
  Dashboard,
  UsernameForgotPassword,
  SSOLogin,
  SSORegister,
  SSOContactUs,
  TnC,
  PrivacyPolicy,
} from "../pages";

export const APP_ROUTES = [
  {
    path: "/",
    element: Landing,
  },
  {
    path: "/login/mobile-number",
    element: MobileNumberLogin,
  },
  {
    path: "/register/mobile-number",
    element: MobileNumberRegister,
  },
  {
    path: "/contact-us/mobile-number",
    element: MobileNumberContactUs,
  },
  {
    path: "/verification/mobile-number",
    element: MobileNumberVerification,
  },
  {
    path: "/login/email-address",
    element: EmailAddressLogin,
  },
  {
    path: "/verification/email-address",
    element: EmailAddressVerification,
  },
  {
    path: "/register/email-address",
    element: EmailAddressRegister,
  },
  {
    path: "/contact-us/email-address",
    element: EmailAddressContactUs,
  },
  {
    path: "/login/nik",
    element: TelkomIdLogin,
  },
  {
    path: "/contact-us/nik",
    element: TelkomIdContactUs,
  },
  {
    path: "/login/username",
    element: UsernameLogin,
  },
  {
    path: "/register/username",
    element: UsernameRegister,
  },
  {
    path: "/contact-us/username",
    element: UsernameContactUs,
  },
  {
    path: "/forgot-password/username",
    element: UsernameForgotPassword,
  },
  {
    path: "/login/sso",
    element: SSOLogin,
  },
  {
    path: "/register/sso",
    element: SSORegister,
  },
  {
    path: "/contact-us/sso",
    element: SSOContactUs,
  },
  {
    path: "/dashboard",
    element: Dashboard,
  },
  {
    path: "/tnc",
    element: TnC,
  },
  {
    path: "/privacy-policy",
    element: PrivacyPolicy,
  },
];
